import { environment } from "../../../environments/environment";


class RequestFileService {
    browserDistFolder = undefined;


    getFile(url: string) {
        try {
            if (!this.browserDistFolder) {
                var { fileURLToPath } = require('url');
                var { dirname, resolve } = require('path');
                const serverDistFolder = dirname(fileURLToPath(import.meta.url));
                this.browserDistFolder = resolve(serverDistFolder, '../browser')
            }



            var { readFileSync } = require('fs');
            var { join } = require('path');
            console.log('url before', url);
            url = url
                .replace(environment.back.i18n, '/assets/i18n/')
                .replace(environment.front.href, '')
                .replace(environment.front.host, '')
            console.log('url after', url);
            const filePath = join(this.browserDistFolder, url);

            console.log('filePath start', filePath);
            const content = readFileSync(filePath, 'utf-8');
            console.log('filePath done', filePath);
            if (url.includes('.json')) {
                return JSON.parse(content)
            }
            return content
        } catch (error) {
            console.log('try load from server ', error);
            throw error
        }
    }
}
export default new RequestFileService()

